import * as React from "react";
import { CLPrescriptionSelect } from "./CLPrescriptionSelect.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLPrescriptionSelectContainer = ({
  attributeConfig: { name, attributeOptions },
  selectClassName,
  eyeSideId,
  onChange,
  isDisabled
}) => {
  const { state, selectors } = useCLEcommContext();
  const selectedValue = state.configurations[eyeSideId].prescription[name]?.toString();
  const { invalidSubmissionsCount } = state.configurator;
  const hasError = React.useMemo(() => {
    const hasSubmissionError = Boolean(invalidSubmissionsCount && !isDisabled && !selectedValue);
    const hasQueryError = selectors.hasNonRecoverableErrorOnEyeside(state, eyeSideId);
    return hasSubmissionError || hasQueryError;
  }, [eyeSideId, invalidSubmissionsCount, isDisabled, selectedValue, selectors, state]);
  return /* @__PURE__ */ React.createElement(
    CLPrescriptionSelect,
    {
      name,
      selectClassName,
      eyeSideId,
      options: attributeOptions,
      isDisabled,
      selectedValue,
      onChange,
      hasError
    }
  );
};
export {
  CLPrescriptionSelectContainer
};
//# sourceMappingURL=CLPrescriptionSelectContainer.js.map
